import React, { useState } from 'react'
import './Header.css'
import { NavLink, Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'


const Header = () => {

    const [hamburgerToggle, setHamburgerToggle] = useState(false)

    const hamburgerToggleHandler = () => {
        setHamburgerToggle(!hamburgerToggle)
    }

    const headerVariants = {
        headerHidden: {
            x: '100vw'
        },
        headerVisible: {
            x: '0vw',
            transition: { duration: .5 }
        },
        headerExit: {
            x: '100vw',
            transition: { duration: .5 },
        }
    }

    const hamburgerVariants = {
        bar1Start: {
            rotate: 0, 
            y: 0
        },
        bar2Start: {
            opacity: 1
        },
        bar3Start: {
            rotate: 0, 
            y: 0
        },
        bar1End: {
            rotate: -45, 
            y: 6
        },
        bar2End: {
            opacity: 0
        },
        bar3End: {
            rotate: 45, 
            y: -16
        }
    }

    const headerBackdropVariants ={
        hiddenFade: {
            opacity: 0
        },
        visibleFade: {
            opacity: 1,
            transition: { delay: .1, duration: .75 }
        },
        exitFade: {
            opacity: 0,
            transition: { delay: .1, duration: .5 }
        }
    }

    
    return (
        <div className="container-header">
            <Link style={{width: "50%", display: "flex"}} to="/" className="container-header-title">
                        
            <svg
            className="logo-big"
            xmlns="http://www.w3.org/2000/svg"
            width="536.601"
            height="65.702"
            viewBox="0 0 536.601 65.702"
            >
            <motion.path
            initial={{pathLength: 0}}
            animate={{pathLength: 1}}
            transition={{duration: 4}}
            fill="none"
            fillRule="evenodd"
            stroke="#B8F4BB"
            strokeLinecap="round"
            strokeWidth="3"
            d="M425.901 14.9h.9a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v36.6h-13.4V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-4.3a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v38.2h-13.4V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-4.3a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v38.2h-13.4V15.9h12.2v2.5q2.761-3.117 8.06-3.458a20.874 20.874 0 011.34-.042h.9a18.539 18.539 0 013.759.354q4.446.922 6.541 4.246 3.1-4.6 10.3-4.6zm-111.8 24.4h-11.1v25.4h-14V0h14v27.1h11.1V0h14v64.7h-14V39.3zm-168-13v38.4h-13.4V0h13.4v17.3a10.225 10.225 0 013.614-1.819q1.457-.417 3.189-.535a20.646 20.646 0 011.397-.046h2.1a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v36.6h-13.4V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5q-1.361 0-1.76 1.154a2.982 2.982 0 00-.14.646zm-44 7.8h10.3a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v5.2a20.333 20.333 0 01-.583 5.103q-2.105 8.097-11.817 8.097h-11.1a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803v-3.1h12.4v4.4q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h8.2a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4v-6q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-10.3a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803v-4.5a20.333 20.333 0 01.583-5.103Q91.39 14.9 101.101 14.9h10.5a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v1.8h-12.4v-3.1q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-7.6a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v5.3q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136zm98.5 20V15.9h13.4v48.8h-12.2v-2.5q-2.761 3.117-8.06 3.458a20.874 20.874 0 01-1.34.042h-2.1a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V15.9h13.4v38.2q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm-178.2 0V0h14v52.5a20.333 20.333 0 01-.583 5.103Q33.713 65.7 24.001 65.7h-11.6a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719A20.767 20.767 0 01.001 52.5v-8.1h13.3v9.7q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.3a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm461.3-39.2h11.3a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v15.8h-22.7v10.2q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4v-5.4h13.4v3.8a20.333 20.333 0 01-.583 5.103q-2.105 8.097-11.817 8.097h-11.3a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103q2.106-8.097 11.817-8.097zm48.9 42.1h4v8.7h-9.4a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V5.3h13.4v10.6h8.4v9.7h-8.4v26.6a11.13 11.13 0 00.069 1.285q.206 1.765 1.031 2.515 1.1 1 3.3 1zm-284.7-37.5v-3.6h11.3v48.8h-11.3v-3.6q-3.1 4.6-10.3 4.6h-2.1a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103q2.106-8.097 11.817-8.097h2.1q5.059 0 8.093 2.27a9.545 9.545 0 012.207 2.33zm114.5 0v-3.6h11.3v48.8h-11.3v-3.6q-3.1 4.6-10.3 4.6h-2.1a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103q2.106-8.097 11.817-8.097h2.1q5.059 0 8.093 2.27a9.545 9.545 0 012.207 2.33zm99.9-19.5v64.7h-13.4V0h13.4zm-382 28.1v24.4a20.333 20.333 0 01-.583 5.103Q77.613 65.7 67.901 65.7h-11.3a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103Q46.89 14.9 56.601 14.9h11.3a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803zm-13.4 27.2V25.2q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v30.1q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm178.9-1.2V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v27.6q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm114.5 0V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v27.6q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm124.4-28v9h9.3v-9q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4z"
            fontSize="12"
            vectorEffect="non-scaling-stroke"
            ></motion.path>
            </svg>

            <svg
            className="logo-small"
            xmlns="http://www.w3.org/2000/svg"
            width="292.301"
            height="65.702"
            viewBox="0 0 292.301 65.702"
            >
            <motion.path
            initial={{pathLength: 0}}
            animate={{pathLength: 1}}
            transition={{duration: 4}}
            fill="none"
            fillRule="evenodd"
            stroke="#B8F4BB"
            strokeLinecap="round"
            strokeWidth="3"
            d="M181.601 14.9h.9a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v36.6h-13.4V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-4.3a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v38.2h-13.4V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-4.3a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v38.2h-13.4V15.9h12.2v2.5q2.761-3.117 8.06-3.458a20.874 20.874 0 011.34-.042h.9a18.539 18.539 0 013.759.354q4.446.922 6.541 4.246 3.1-4.6 10.3-4.6zm-111.8 24.4h-11.1v25.4h-14V0h14v27.1h11.1V0h14v64.7h-14V39.3zm-47.4 14.8V0h14v52.5a20.333 20.333 0 01-.583 5.103Q33.713 65.7 24.001 65.7h-11.6a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719A20.767 20.767 0 01.001 52.5v-8.1h13.3v9.7q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.3a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm217-39.2h11.3a16.742 16.742 0 014.983.678q5.476 1.707 6.909 7.719a20.767 20.767 0 01.508 4.803v15.8h-22.7v10.2q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4v-5.4h13.4v3.8a20.333 20.333 0 01-.583 5.103q-2.105 8.097-11.817 8.097h-11.3a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103q2.106-8.097 11.817-8.097zm48.9 42.1h4v8.7h-9.4a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V5.3h13.4v10.6h8.4v9.7h-8.4v26.6a11.13 11.13 0 00.069 1.285q.206 1.765 1.031 2.515 1.1 1 3.3 1zm-170.2-37.5v-3.6h11.3v48.8h-11.3v-3.6q-3.1 4.6-10.3 4.6h-2.1a16.742 16.742 0 01-4.982-.678q-5.476-1.707-6.91-7.719a20.767 20.767 0 01-.508-4.803V28.1a20.333 20.333 0 01.583-5.103Q95.99 14.9 105.701 14.9h2.1q5.059 0 8.093 2.27a9.545 9.545 0 012.207 2.33zm99.9-19.5v64.7h-13.4V0h13.4zm-102 54.1V26.5q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4v27.6q0 .8.55 1.4a1.837 1.837 0 00.645.464 1.804 1.804 0 00.705.136h5.5a1.751 1.751 0 001.294-.541 2.191 2.191 0 00.056-.059q.55-.6.55-1.4zm124.4-28v9h9.3v-9q0-.8-.55-1.4a1.837 1.837 0 00-.644-.464 1.804 1.804 0 00-.706-.136h-5.5a1.751 1.751 0 00-1.293.541 2.191 2.191 0 00-.057.059q-.55.6-.55 1.4z"
            fontSize="12"
            vectorEffect="non-scaling-stroke"
            ></motion.path>
            </svg>
            
            </Link>
            <div className="container-header-links">
                <NavLink activeClassName="header-links-active" to="/" exact>Projects</NavLink>
                <NavLink activeClassName="header-links-active" to="/contact" >Contact</NavLink>
                <NavLink activeClassName="header-links-active" to="/about" >About</NavLink>
            </div>

            <div className="header-hamburger">
                <div className="hamburger-toggle-button" onClick={hamburgerToggleHandler}>
                    <motion.div className="ham-bar-1"
                    variants={hamburgerVariants}
                    initial={!hamburgerToggle ? "bar1Start" : "bar1End"}
                    animate={!hamburgerToggle ? "bar1Start" : "bar1End"} />
                    <motion.div className="ham-bar-2"
                    variants={hamburgerVariants}
                    initial={!hamburgerToggle ? "bar2Start" : "bar2End"}
                    animate={!hamburgerToggle ? "bar2Start" : "bar2End"} />
                    <motion.div className="ham-bar-3"
                     variants={hamburgerVariants}
                     initial={!hamburgerToggle ? "bar3Start" : "bar3End"}
                     animate={!hamburgerToggle ? "bar3Start" : "bar3End"} />
                </div>
            </div>            

            <AnimatePresence exitBeforeEnter>
            {hamburgerToggle &&
            <>

                <motion.div className="hamburger-toggle-backdrop"
                variants={headerBackdropVariants}
                initial="hiddenFade"
                animate="visibleFade"
                exit="exitFade"
                onClick={hamburgerToggleHandler}/>

                <motion.div 
                className="toggle-modal"
                variants={headerVariants}
                initial="headerHidden"
                animate="headerVisible"
                exit="headerExit"
                >
                <NavLink onClick={hamburgerToggleHandler} activeClassName="header-links-active" to="/" exact>Projects</NavLink>
                <NavLink onClick={hamburgerToggleHandler} activeClassName="header-links-active" to="/contact" >Contact</NavLink>
                <NavLink onClick={hamburgerToggleHandler} activeClassName="header-links-active" to="/about" >About</NavLink>
                </motion.div>

            </>
            }
            </AnimatePresence>

        </div>
    )
    
}

export default Header